<form
  [formGroup]="form"
  *ngIf="form && categories"
  (submit)="save()"
  class="form-b4a category-form"
  [class.editable]="model"
>
  <span class="p-float-label" *ngIf="categoriesForDropdown">
    <p-dropdown
      formControlName="parentId"
      appendTo="body"
      [autoDisplayFirst]="false"
      [options]="categoriesForDropdown"
      optionValue="categoryId"
      (onChange)="validateExternalId()"
    >
      <ng-template pTemplate="item" let-category>
        {{ category.externalIdString || '' }} {{ category.category }}
      </ng-template>
      <ng-template pTemplate="selectedItem" *ngIf="parent">
        {{ parent?.externalIdString || '' }}
        {{ parent?.category }}
      </ng-template>
    </p-dropdown>
    <label for="parentId">Categoria superior</label>
  </span>
  <span class="p-float-label">
    <p-inputNumber
      (onInput)="validateExternalId()"
      (onBlur)="validateExternalId()"
      inputId="externalId"
      formControlName="externalId"
    />
    <label for="externalId">ID Externo *</label>
    <small
      class="error"
      *ngIf="
        form.controls['externalId'].errors &&
        form.controls['externalId'].errors['min']
      "
    >
      Mínimo {{ form.controls['externalId'].errors['min']['min'] }}
    </small>
    <small
      class="error"
      *ngIf="
        form.controls['externalId'].errors &&
        form.controls['externalId'].errors['required']
      "
    >
      O ID Externo é obrigatório
    </small>
    <small
      class="error"
      *ngIf="
        form.controls['externalId'].errors &&
        form.controls['externalId'].errors['exists'] &&
        conflictCategory
      "
    >
      Já existe uma categoria com a referência
      {{ externalId }} ({{ conflictCategory.category }})
    </small>
    <small
      *ngIf="conflictCategory && last && last.categoryId !== model?.categoryId"
    >
      *Sugestão:
      <b>{{ last.externalId + 1 }} </b></small
    >
  </span>
  <span class="p-float-label">
    <input
      type="text"
      pInputText
      formControlName="displayName"
      name="displayName"
      id="displayName"
    />
    <label for="displayName">Nome *</label>
  </span>
  <div class="buttons" *ngIf="permission">
    <p-button label="Salvar" type="submit" [disabled]="!form.valid"></p-button>
  </div>
</form>

<p-confirmDialog />
<p-toast />
